import { useEffect, useState, useRef } from 'react'
import { userServices } from '../../../../services/users/index'
import DefaultLayout from '../../../../layouts/DefaultLayout'
import {
  Avatar,
  Button,
  Flex,
  Grid,
  GridItem,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react'
import { FaCheckCircle, FaTimesCircle, FaExclamationTriangle, FaFileContract, FaUserFriends } from 'react-icons/fa'
import { MdAccountBox } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

// Icon

import AlertDialogComponent from '../../../../components/dialog/AlertDialogComponent'
import GeneralCard from '../../../../components/cards/generalCard/GeneralCard'
import LoadingComponent from '../../../../components/shareds/LoadingComponent'
import StatusCard from '../../../../components/cards/statusCard/StatusCard'
import NavCard from '../../../../components/cards/navCard/NavigateCard'
import CustomModal from '../../../../components/modal/CustomModal'

import UserContractCreate from '../../userContracts/create'
import UserAddressCreate from '../../userAddresses/create'
import UserSocialCreate from '../../userSocials/create'
import UserPhoneCreate from '../../userPhones/create'
import UserEmailCreate from '../../userEmails/create'
import UserAddress from '../../userAddresses/index'
import UserNoteCreate from '../../userNotes/create'
import SharedDetail from '../../../sharedDetails'
import UserContract from '../../userContracts'
import UserSocial from '../../userSocials'
import UserPhone from '../../userPhones'
import UserEmail from '../../userEmails'
import UserNote from '../../userNotes'
import UserFile from '../../userFlies'
import CalendarComponent from '../../../../components/calendar'

const UserDetail = () => {
  const [userData, setUserData] = useState<any | null>(null)
  const { isOpen: isOpenAddress, onOpen: onOpenAddress, onClose: onCloseAddress } = useDisclosure()
  const { isOpen: isOpenPhone, onOpen: onOpenPhone, onClose: onClosePhone } = useDisclosure()
  const { isOpen: isOpenSocial, onOpen: onOpenSocial, onClose: onCloseSocial } = useDisclosure()
  const { isOpen: isOpenNote, onOpen: onOpenNote, onClose: onCloseNote } = useDisclosure()
  const { isOpen: isOpenEmail, onOpen: onOpenEmail, onClose: onCloseEmail } = useDisclosure()
  const { isOpen: isOpenContract, onOpen: onOpenContract, onClose: onCloseContract } = useDisclosure()
  const [statusData, setStatus] = useState<any | null>(null)
  const id = location.pathname.split('/influencer/')[1]
  const navigate = useNavigate()

  const [isOpenAlert, setIsOpen] = useState(false)
  const onCloseAlert = () => setIsOpen(false)
  const cancelRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    userServices.findOne(id).then((response) => {
      setUserData(response.data)
    })
    userServices.statusList().then((response) => {
      setStatus(response.data)
    })
  }, [])

  const deleteUser = () => {
    userServices.remove(id).finally(() => {
      onCloseAlert()
      navigate('/manage-employee')
    })
  }

  const deleteFunction = () => {
    setIsOpen(true)
  }

  if (!userData) {
    return <LoadingComponent />
  }

  return (
    <DefaultLayout>
      <NavCard
        icon={MdAccountBox}
        pageName='Influencer'
        firstButton='Update'
        firstButtonLink={`/influencer/update/${id}`}
        secondButton='Delete'
        secondClickAction={deleteFunction}
      />
      <GeneralCard title='Influencer Profile'>
        <Grid templateRows='repeat(2, 1fr)' templateColumns='repeat(5, 1fr)' gap={4} margin={'20px'}>
          <GridItem
            colSpan={3}
            children={
              <HStack>
                <Avatar size={'md'} />
                <VStack display={{ base: 'none', md: 'flex' }} alignItems='flex-end' spacing='1px' ml='2'>
                  <Text fontSize='2xl' fontWeight='bold' children={userData.firstName + ' ' + userData.lastName} />
                  <Text fontSize='xs' color='gray.600' children={userData.userType.toUpperCase()} />
                </VStack>
                <VStack display={{ base: 'none', md: 'flex' }} alignItems='flex-end' spacing='1px' ml='2'>
                  <Text fontWeight='bold' color={'blue'} children={userData.email} />
                  <Text fontSize='xs' color='gray.600' children={userData.languageCode.toUpperCase()} />
                </VStack>
              </HStack>
            }
          />
          <GridItem
            colSpan={2}
            children={
              <Flex float={'right'}>
                <HStack float={'right'} marginRight={'20px'}>
                  <VStack display={{ base: 'none', md: 'flex' }} alignItems='flex-end' spacing='1px' ml='2'>
                    <Text fontSize='sm' children={'CONTRACT VALUE'} />
                    <Text fontSize='xl' fontWeight='bold' color='red.600' children={`0$`} />
                  </VStack>
                </HStack>
                <HStack float={'right'} marginRight={'20px'}>
                  <VStack display={{ base: 'none', md: 'flex' }} alignItems='flex-end' spacing='1px' ml='2'>
                    <Text fontSize='sm' children={'REFERRED VALUE'} />
                    <Text fontSize='xl' fontWeight='bold' color='red.600' children={`0$`} />
                  </VStack>
                </HStack>
                <HStack float={'right'} marginRight={'20px'}>
                  <VStack display={{ base: 'none', md: 'flex' }} alignItems='flex-end' spacing='1px' ml='2'>
                    <Text fontSize='sm' children={'TOTAL VALUE'} />
                    <Text fontSize='xl' fontWeight='bold' color='red.600' children={`0$`} />
                  </VStack>
                </HStack>
              </Flex>
            }
          />
          <GridItem
            colSpan={1}
            children={<StatusCard icon={FaCheckCircle} name={'SHARED POSTS'} value={0} link={''} key={'item.name'} />}
          />
          <GridItem
            colSpan={1}
            children={
              <StatusCard icon={FaTimesCircle} name={'NOT-SHARED POSTS'} value={2} link={''} key={'item.name'} />
            }
          />
          <GridItem
            colSpan={1}
            children={
              <StatusCard icon={FaExclamationTriangle} name={'WAITING POSTS'} value={2} link={''} key={'item.name'} />
            }
          />
          <GridItem
            colSpan={1}
            children={
              <StatusCard icon={FaFileContract} name={'ACTIVE CONTRATS'} value={2} link={''} key={'item.name'} />
            }
          />
          <GridItem
            colSpan={1}
            children={<StatusCard icon={FaUserFriends} name={'REFERRALS'} value={2} link={''} key={'item.name'} />}
          />
        </Grid>
      </GeneralCard>

      <GeneralCard title='Detail'>
        <>
          <AlertDialogComponent
            isOpen={isOpenAlert}
            onClose={onCloseAlert}
            cancelRef={cancelRef}
            onConfirm={deleteUser}
          />
        </>
        <Tabs size='lg' variant='enclosed'>
          <TabList>
            <Tab children='Addresses' />
            <Tab children='Phones' />
            <Tab children='Socials' />
            <Tab children='Notes' />
            <Tab children='Emails' />
          </TabList>
          <TabPanels>
            <TabPanel>
              <UserAddress />
              <Button colorScheme='red' onClick={onOpenAddress} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Address Create'
                isOpen={isOpenAddress}
                onClose={onCloseAddress}
                key={'User_Address_Create'}
                children={<UserAddressCreate />}
              />
            </TabPanel>

            <TabPanel>
              <UserPhone />
              <Button colorScheme='red' onClick={onOpenPhone} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Phone Create'
                isOpen={isOpenPhone}
                onClose={onClosePhone}
                key={'User_Phone_Create'}
                children={<UserPhoneCreate />}
              />
            </TabPanel>

            <TabPanel>
              <UserSocial />
              <Button colorScheme='red' onClick={onOpenSocial} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Social Create'
                isOpen={isOpenSocial}
                onClose={onCloseSocial}
                key={'User_Social_Create'}
                children={<UserSocialCreate />}
              />
            </TabPanel>

            <TabPanel>
              <UserNote />
              <Button colorScheme='red' onClick={onOpenNote} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Note Create'
                isOpen={isOpenNote}
                onClose={onCloseNote}
                key={'User_Note_Create'}
                children={<UserNoteCreate />}
              />
            </TabPanel>

            <TabPanel>
              <UserEmail />
              <Button colorScheme='red' onClick={onOpenEmail} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Email Create'
                isOpen={isOpenEmail}
                onClose={onCloseEmail}
                key={'User_Email_Create'}
                children={<UserEmailCreate />}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </GeneralCard>

      <GeneralCard title='ORM'>
        <Tabs size='lg' variant='enclosed'>
          <TabList>
            <Tab children='Contracts' />
            <Tab children='Files' />
            <Tab children='Shares' />
            <Tab children='Post History' />
          </TabList>
          <TabPanels>
            <TabPanel>
              <UserContract />
              <Button colorScheme='red' onClick={onOpenContract} mt={'20px'} children={'Create'} />
              <CustomModal
                title='User Contract Create'
                isOpen={isOpenContract}
                onClose={onCloseContract}
                key={'User_Contract_Create'}
                size={'6xl'}
                children={<UserContractCreate />}
              />
            </TabPanel>

            <TabPanel>
              <UserFile />
            </TabPanel>

            <TabPanel>
              <SharedDetail />
            </TabPanel>

            <TabPanel>
              <CalendarComponent />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </GeneralCard>
    </DefaultLayout>
  )
}

export default UserDetail
